import { useCallback } from 'react';

import { useBackgroundColor } from '~extension/icon-library/context/BackgroundColor';
import { ColorPickerComp } from './ColorPickerComp';
import { PickerItem } from './PickerItem';

type BackgroundColorPickerProps = {
  disabled?: boolean;
};

export const BackgroundColorPicker = ({ disabled }: BackgroundColorPickerProps) => {
  const { availableBackgroundColors, selectedBackgroundColor, setBackgroundColor, resetBackgroundColor } =
    useBackgroundColor();

  const handleColorOptionClick = useCallback(
    (color: string) => () => {
      if (!disabled) {
        setBackgroundColor(color);
      }
    },
    [disabled, setBackgroundColor],
  );

  const handleColorpOptionDefaultClick = useCallback(() => {
    if (!disabled) {
      resetBackgroundColor();
    }
  }, [disabled, resetBackgroundColor]);

  if (availableBackgroundColors?.length) {
    return (
      <ColorPickerComp>
        <PickerItem selected={!selectedBackgroundColor} onClick={handleColorpOptionDefaultClick} />
        {availableBackgroundColors.map(color => {
          return (
            <PickerItem
              key={color}
              color={color}
              selected={color === selectedBackgroundColor}
              onClick={handleColorOptionClick(color)}
            />
          );
        })}
      </ColorPickerComp>
    );
  }
  return null;
};
